import { useMemo } from "react";
import { InstrumentType } from "@orb-labs/types";
import { extractChartData } from "@orb-labs/orby-core";
import { GetFungibleTokenOneDayChartQuery, GetPerpetualOneDayChartQuery, GetPredictionOneDayChartQuery, } from "../graphql/queries.js";
import { useBullrunUseQuery } from "../hooks/bullrunQueries/BullrunUseQueryContext.js";
function extractTokenChart(data) {
    const d = data;
    return extractChartData(d?.getStandardizedFungibleToken?.marketData?.chartData)?.oneDay;
}
function extractPerpChart(data) {
    const d = data;
    return extractChartData(d?.getStandardizedPerpetual?.markets?.[0]?.chartData)?.oneDay;
}
function extractPredictionChart(data) {
    const d = data;
    const outcomes = d?.getStandardizedPredictionEvent?.markets?.[0]?.outcomes;
    if (!outcomes?.length)
        return undefined;
    const leading = [...outcomes].sort((a, b) => Number(b.price?.end?.value ?? 0) - Number(a.price?.end?.value ?? 0))[0];
    return extractChartData(leading?.chartData)?.oneDay;
}
const CONFIG = {
    [InstrumentType.FUNGIBLE_TOKEN]: { query: GetFungibleTokenOneDayChartQuery, extract: extractTokenChart },
    [InstrumentType.PERPETUAL_CONTRACT]: { query: GetPerpetualOneDayChartQuery, extract: extractPerpChart },
    [InstrumentType.PREDICTION_MARKET]: { query: GetPredictionOneDayChartQuery, extract: extractPredictionChart },
};
export function useInstrumentOneDayChart(instrument, enabled) {
    const useQueryLike = useBullrunUseQuery();
    const config = instrument ? CONFIG[instrument.type] : undefined;
    const { data, loading } = useQueryLike(config?.query ?? GetFungibleTokenOneDayChartQuery, {
        skip: !enabled || !instrument || !config,
        fetchPolicy: "no-cache",
        variables: {
            input: { standardizedInstrumentId: instrument?.id },
        },
    });
    const chartData = useMemo(() => {
        if (!data || !config)
            return undefined;
        return config.extract(data);
    }, [data, config]);
    return { chartData, loading };
}
